module.exports = __webpack_public_path__ + "static/media/STFU1.87eeffd7.png";